module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('select', {
    staticClass: "form-control margin-bottom",
    attrs: {
      "name": _vm.item.name,
      "disabled": _vm.item.disabled
    },
    on: {
      "input": _vm.update
    }
  }, [(_vm.item.value !== '') ? _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.item.placeholder))]) : _c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.item.placeholder))]), _vm._v(" "), _vm._l((_vm.item.select_options), function(option) {
    return (_vm.item.value !== option.value) ? _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))]) : _c('option', {
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.text))])
  })], 2), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      staticClass: "to-up",
      class: {
        'margin-left': _vm.item.type == 'checkbox'
      },
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b82058e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input-components/emt-select.vue
// module id = 99
// module chunks = 0